import React, { useMemo } from 'react'
import { Alert } from 'antd'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { loadedInitSelector, marketplaceConnectsSelector } from 'app-redux/selectors'
import useMemoizeCheckPermission from 'utils/hooks/useMemoizeCheckPermission'
import { useMarketplaceConnects } from 'utils/queries'
import LazadaReconnectAlert from 'components/apps/Marketplace/LazadaReconnectAlert'

const MarketplaceConnectionAlert = () => {
  const { formatMessage } = useIntl()
  const { pathname } = useLocation()
  const loadedInit = useSelector(loadedInitSelector)
  const marketplaceConnects = useSelector(marketplaceConnectsSelector)
  const hasMarketplaceConnect = useMemoizeCheckPermission({ permission: 'marketplace_connect' })
  const canManageConnect = useMemoizeCheckPermission({ permission: 'marketplace_connect_manage' })

  const { data } = useMarketplaceConnects({
    params: {},
    options: { enabled: loadedInit && hasMarketplaceConnect && marketplaceConnects.length > 0 },
  })

  // Kalau lebih dari satu toko terputus, nama toko dirangkai dalam satu banner supaya kalimat yang
  // isinya identik tidak berulang dan konten halaman tidak kedorong jauh ke bawah.
  const disconnectedShopNames = useMemo(
    () =>
      (data?.marketplace_connect?.data || [])
        .filter((store) => store.status !== 1)
        .map((store) => store.shop_name)
        .join(', '),
    [data],
  )

  // Halaman Marketplace Connect sudah menampilkan banner ini sendiri
  const lazadaReconnectCount = useMemo(
    () =>
      canManageConnect && pathname !== '/settings/marketplaceConnect'
        ? (data?.marketplace_connect?.data || []).filter((store) => store.marketplace === 'lazada')
            .length
        : 0,
    [canManageConnect, data, pathname],
  )

  if (!disconnectedShopNames && !lazadaReconnectCount) {
    return null
  }

  return (
    <>
      {disconnectedShopNames ? (
        <Alert
          type="error"
          showIcon
          closable
          message={formatMessage(
            { id: 'marketplaceConnect.status_error_message' },
            { shopName: disconnectedShopNames },
          )}
        />
      ) : null}
      {lazadaReconnectCount > 0 ? (
        <LazadaReconnectAlert count={lazadaReconnectCount} closable />
      ) : null}
    </>
  )
}

export default MarketplaceConnectionAlert
